import { VoteOutlineIcon } from './VoteOutlineIcon';

/**
 * author: Google
 * id 392D2435-0B0E-4CDA-A542-FAB319411B8A
 * name vote-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vote-outline.svg
 * tags
 */
export const HowToVoteOutlineIcon = VoteOutlineIcon;
export default HowToVoteOutlineIcon